import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import get from 'lodash/get';
import { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { connectAutoComplete } from 'react-instantsearch-core';
import { useFieldError, useLinkedContent } from 'libs/content/hooks';
import { hitsToLinkedContents } from 'libs/content/transformers/hitsToLinkedContents';

var AlgoliaAutocomplete = function AlgoliaAutocomplete(_ref) {
  var _ref2;

  var hits = _ref.hits,
      refine = _ref.refine,
      name = _ref.name,
      label = _ref.label,
      defaultValue = _ref.defaultValue;

  // useFormContext is not using keyword 'this' so it's safe to ignore:
  // eslint-disable-next-line @typescript-eslint/unbound-method
  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      setValue = _useFormContext.setValue;

  var errorMessage = useFieldError(name);

  var _useLinkedContent = useLinkedContent(defaultValue === undefined ? '' : (_ref2 = get(control._defaultValues, name)) !== null && _ref2 !== void 0 ? _ref2 : ''),
      _useLinkedContent2 = _slicedToArray(_useLinkedContent, 2),
      content = _useLinkedContent2[0],
      setContent = _useLinkedContent2[1];

  var handleChange = useCallback(function (event, newValue) {
    var _newValue$id;

    setContent(newValue);
    setValue(name, (_newValue$id = newValue === null || newValue === void 0 ? void 0 : newValue.id) !== null && _newValue$id !== void 0 ? _newValue$id : '');
  }, [setContent, setValue, name]);
  var handleInputChange = useCallback(function (event, newInputValue) {
    refine(newInputValue);
  }, [refine]);
  var handleRenderInput = useCallback(function (params) {
    return __jsx(Controller, {
      defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '',
      name: name,
      render: function render() {
        return __jsx(TextField, _extends({}, params, {
          id: "form-field-".concat(name),
          error: Boolean(errorMessage),
          helperText: errorMessage,
          name: name,
          label: label,
          variant: "outlined"
        }));
      }
    });
  }, [label, name, errorMessage, defaultValue]);
  var options = useMemo(function () {
    return hitsToLinkedContents(hits);
  }, [hits]);
  return __jsx(Autocomplete, {
    value: content,
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    getOptionSelected: function getOptionSelected() {
      return true;
    },
    onChange: handleChange,
    onInputChange: handleInputChange,
    renderInput: handleRenderInput // Setting `filterOptions` as the identity function allows to let algolia do the filtering
    ,
    filterOptions: function filterOptions(algoliaOptions) {
      return algoliaOptions;
    }
  });
};

var AutocompleteInput = connectAutoComplete(AlgoliaAutocomplete);
export default AutocompleteInput;